import { Column } from 'react-table';
import { Label } from '@britishcouncil/react-admin';

import { OsmMonitoringDto, OsmMonitoringStatus, OsmMonitoringResult } from 'api';
import { formatDate } from 'utils';
import { ViewDetailsButton } from 'components';
import { getOsmMonitoringResultName, getOsmMonitoringTypeName } from 'const';
import { SelectionCell, FollowUpCell } from '../common';

const getStatusBadge = (status: OsmMonitoringStatus) => {
  switch (status) {
    case OsmMonitoringStatus.Current:
      return <Label color="green">Current</Label>;
    case OsmMonitoringStatus.Archived:
      return <Label color="yellow">Archived</Label>;
    case OsmMonitoringStatus.Deleted:
      return <Label color="red">Deleted</Label>;
    default:
      return null;
  }
};

export const columns: Column<OsmMonitoringDto>[] = [
  {
    Header: ' ',
    id: 'selection',
    width: '50px',
    disableSortBy: true,
    Cell: ({ row }) => (
      <SelectionCell
        row={row}
        isSelectable={(data) => data.status === OsmMonitoringStatus.Current}
        disabledMessage="Only current monitoring records can be deleted"
      />
    ),
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: '110px',
    Cell: ({ value }) => getStatusBadge(value),
  },
  {
    Header: 'Date of monitoring',
    accessor: 'monitoringDate',
    width: 'auto',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Type of monitoring',
    accessor: 'type',
    width: 'auto',
    Cell: ({ value }) => <>{getOsmMonitoringTypeName(value)}</>,
  },
  {
    Header: 'Monitoring Result',
    accessor: 'result',
    width: 'auto',
    Cell: ({ value }) => <>{getOsmMonitoringResultName(value)}</>,
  },
  {
    Header: 'Total of Result',
    accessor: 'totalOfResult',
    width: 'auto',
  },
  {
    Header: 'Follow-up completed',
    accessor: 'hasFollowUp',
    width: '150px',
    Cell: ({ row }) => (
      <FollowUpCell
        row={row}
        isDisabled={(data) =>
          data.result === OsmMonitoringResult.Phase0 ||
          data.result === OsmMonitoringResult.Standard ||
          data.result === OsmMonitoringResult.Active ||
          data.status !== OsmMonitoringStatus.Current
        }
        disabledMessage="Follow-up cannot be added for this record"
      />
    ),
  },
  {
    Header: 'Details',
    id: 'actions',
    width: '50px',
    Cell: ({ row }) => <ViewDetailsButton to={`${row.original.id}`} />,
    disableSortBy: true,
  },
];
